
import initialState from '../store/initial-state'
import { CLOSE_BUNKEY_HOST, SET_BUNKEY_HOST } from "../constants/bunkey-host-types"
export default (state = initialState.bunkeyHost, action) => {

    const { payload } = action
    switch (action.type) {
        case CLOSE_BUNKEY_HOST:
            return {
                ...state,
                asset: null,
                show: false,
            }

        case SET_BUNKEY_HOST:
            return {
                asset: payload.asset,
                show: true
            }

        default: return { ...state }
    }
}